import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react'
import toast from 'react-hot-toast';
import { downloadDraft as downloadDraftAPI} from 'services/apiReport';

const useDownloadDraft = () => {
  const queryClient = useQueryClient();
  const {isPending: isDownloadingDraft, isSuccess: DraftDownloaded, mutate: downloadDraft,data} = useMutation({
    mutationFn: downloadDraftAPI,
    onSuccess:(data)=>{
        toast.success("Downloading Started....")
    },
    onError:(error)=>{
        toast.error(error?.data?.message || "An error occurred while downloading the draft")
        console.error("Error occurred:",error)
    }
  })

  return{isDownloadingDraft,DraftDownloaded,downloadDraft,data}
}

export default useDownloadDraft
